import * as React from 'react';

import { StringDisplay } from '../../Fields';
import { StringReadOnlyViewProps } from '../types';

interface CreditReportTeamReadOnlyViewProps extends StringReadOnlyViewProps {
  after?: React.ReactNode;
}

export const CreditReportReadOnlyTeamView = (props: CreditReportTeamReadOnlyViewProps) => (
  <StringDisplay title={'Credit history retrieval'} after={props.after} value={props.value} textSize={'sm'} />
);
